import type { ComponentPropsWithoutRef } from 'react'

const ModalHeader = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div className={`flex h-17 items-center justify-between ${className}`} {...props} />
)

export default ModalHeader
